// import React from "react";
// import styles from "./Features.module.css";
// import FeatureItem from "./FeatureItem";
// import { Link } from "react-router-dom";
// import { useTranslation } from "react-i18next";

// const Features = () => {
//   const { t } = useTranslation();

//   const featureData = [
//     {
//       id: 1,
//       title: t("features.earnPoints.title"),
//       description: t("features.earnPoints.description"),
//       imageBg: "/images/iphone-feature-bg-03.svg",
//       image: "/images/home.png",
//     },
//     {
//       id: 2,
//       title: t("features.unlockOffers.title"),
//       description: t("features.unlockOffers.description"),
//       imageBg: "/images/iphone-feature-bg-02.svg",
//       image: "/images/offers.png",
//     },
//     {
//       id: 3,
//       title: t("features.scanShops.title"),
//       description: t("features.scanShops.description"),
//       imageBg: "/images/iphone-feature-bg-01.svg",
//       image: "/images/shops.png",
//     },
//     {
//       id: 4,
//       title: t("features.redeemCelebrate.title"),
//       description: t("features.redeemCelebrate.description"),
//       imageBg: "/images/iphone-feature-bg-04.svg",
//       image: "/images/redeem.png",
//     },
//     {
//       id: 5,
//       title: t("features.referEarn.title"),
//       description: t("features.referEarn.description"),
//       imageBg: "/images/iphone-feature-bg-03.svg",
//       image: "/images/refer.png",
//     },
//     {
//       id: 6,
//       title: t("features.spinWin.title"),
//       description: t("features.spinWin.description"),
//       imageBg: "/images/iphone-feature-bg-02.svg",
//       image: "/images/spinwheel.png",
//     },
//     {
//       id: 7,
//       title: t("features.joinVendor.title"),
//       description: t("features.joinVendor.description"),
//       imageBg: "/images/iphone-feature-bg-04.svg",
//       image: "/images/vendor.png",
//       isVendor: true,
//     },
//   ];

//   return (
//     <section className={styles.featuresExtended}>
//       <div className={styles.featuresExtendedInner}>
//         <div className={styles.featuresExtendedWrap}>
//           <div className={styles.container}>
//             {featureData.map((feature, index) => (
//               <FeatureItem key={feature.id} feature={feature} index={index} />
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Features;








import React from "react";
import styles from "./Features.module.css";
import FeatureItem from "./FeatureItem";
import { useTranslation } from "react-i18next";

const Features = () => {
  const { t } = useTranslation();

  const featureData = [
    {
      id: 1,
      title: t("features.earnPoints.title"),
      description: t("features.earnPoints.description"),
      imageBg: "/images/iphone-feature-bg-03.svg",
      image: "/images/home.png",
    },
    {
      id: 2,
      title: t("features.unlockOffers.title"),
      description: t("features.unlockOffers.description"),
      imageBg: "/images/iphone-feature-bg-02.svg",
      image: "/images/offers.png",
    },
    {
      id: 3,
      title: t("features.scanShops.title"),
      description: t("features.scanShops.description"),
      imageBg: "/images/iphone-feature-bg-01.svg",
      image: "/images/shops.png",
    },
    {
      id: 4,
      title: t("features.redeemCelebrate.title"),
      description: t("features.redeemCelebrate.description"),
      imageBg: "/images/iphone-feature-bg-04.svg",
      image: "/images/redeem.png",
    },
    {
      id: 5,
      title: t("features.referEarn.title"),
      description: t("features.referEarn.description"),
      imageBg: "/images/iphone-feature-bg-03.svg",
      image: "/images/refer.png",
    },
    {
      id: 6,
      title: t("features.spinWin.title"),
      description: t("features.spinWin.description"),
      imageBg: "/images/iphone-feature-bg-02.svg",
      image: "/images/spinwheel.png",
    },
    {
      id: 7,
      title: t("features.joinVendor.title"),
      description: t("features.joinVendor.description"),
      imageBg: "/images/iphone-feature-bg-04.svg",
      image: "/images/vendor.png",
      isVendor: true,
    },
  ];

  return (
    <section className={styles.featuresExtended}>
      <div className={styles.featuresExtendedInner}>
        <div className={styles.featuresExtendedWrap}>
          <div className={styles.container}>
            {featureData.map((feature, index) => (
              <FeatureItem key={feature.id} feature={feature} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;

